import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.dataset.finetune.detail');
import { OnInit, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
    selector: 'wiz-page-dataset-finetune-detail',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.dataset.finetune.detail/view.scss */
:host {
  display: block;
  height: 100%;
}

.scrollbar-hide {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.scrollbar-hide::-webkit-scrollbar {
  display: none;
}`],
})
export class PageDatasetFinetuneDetailComponent implements OnInit, OnDestroy {
    public dataset: any = null;
    public collection: any = null;
    public qaList: any[] = [];
    public loading: boolean = true;
    public qaLoading: boolean = false;
    public page: number = 1;
    public totalPages: number = 1;
    public id: string = '';

    // Toolbar state
    public models: any[] = [
        { id: 'gpt-5', name: 'GPT-5', provider: 'OpenAI' },
        { id: 'gpt-5-mini', name: 'GPT-5 Mini', provider: 'OpenAI' },
        { id: 'gpt-5-turbo', name: 'GPT-5 Turbo', provider: 'OpenAI' },
        { id: 'gemini-3.1-pro-preview', name: 'Gemini 3.1 Pro Preview', provider: 'Google' },
        { id: 'gemini-3-flash-preview', name: 'Gemini 3 Flash Preview', provider: 'Google' },
        { id: 'gemini-3.1-flash-lite-preview', name: 'Gemini 3.1 Flash Lite Preview', provider: 'Google' },
    ];
    public selectedModel: any = this.models[0];
    public showModelDropdown: boolean = false;
    public showDownloadDropdown: boolean = false;
    public showDownloadUsers: boolean = false;
    public downloadUserList: any[] = [];
    public downloadUsersLoading: boolean = false;
    public generating: boolean = false;
    public uploading: boolean = false;

    // Generate modal state
    public showGenerateModal: boolean = false;
    public generateCount: number = 10;
    public selectedSourceMode: string = 'single';
    public readonly multiFileTopK: number = 3;

    // Generate progress state
    public showProgressModal: boolean = false;
    public progressStep: string = '';
    public progressMessage: string = '';
    public progressPercent: number = 0;
    public progressSaved: number = 0;
    public progressTotal: number = 0;
    public progressError: string = '';
    public progressDone: boolean = false;
    public progressSelectedFiles: string[] = [];
    public progressSelectedFileDetails: any[] = [];
    public progressContextLabel: string = '';
    public progressSelectionStrategy: string = '';

    // Source display state
    public expandedSources: any = {};

    // PDF viewer modal state
    public showPdfViewer: boolean = false;
    public pdfViewerSrc: any = null;
    public pdfImageUrl: string = '';

    // Label selection state
    public selectedMainLabels: string[] = ['summary'];
    public subLabelMap: any = {};

    // Prompt management state
    public prompts: any = {};
    public promptsLoading: boolean = false;
    public promptUserId: string = '';
    public promptUsers: any[] = [];
    public showPromptUserDropdown: boolean = false;
    public activePromptTab: string = 'system';
    public promptSaving: boolean = false;

    // Label definitions
    public mainLabels: any[] = [
        { key: 'summary', name: '요약' },
        { key: 'concept', name: '개념설명' },
        { key: 'reasoning', name: '인과/기전' },
        { key: 'decision', name: '진단/변증' },
        { key: 'treatment_principle', name: '치료원칙' },
        { key: 'prescription', name: '처방운용' },
        { key: 'procedure', name: '시술절차' },
    ];
    public subLabels: any[] = [
        { key: 'evidence', name: '근거제시' },
        { key: 'compare', name: '비교분석' },
        { key: 'safety', name: '안전/주의' },
    ];

    // Assign modal state
    public assignedUsers: any[] = [];
    public showAssignModal: boolean = false;
    public userList: any[] = [];
    public loadingUsers: boolean = false;
    public selectedUserIds: string[] = [];

    // Delete QA modal state
    public showDeleteQaModal: boolean = false;
    public deleteQaTarget: any = null;

    private routerSub: Subscription;

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    public async ngOnInit() {
        await this.service.init();
        this.id = WizRoute.segment.id;
        if (!this.id) {
            this.service.href('/dataset/finetune');
            return;
        }
        await this.loadDataset();
        await this.service.render();

        this.routerSub = this.router.events.subscribe(async (event) => {
            if (event instanceof NavigationEnd) {
                const newId = WizRoute.segment.id;
                if (newId && newId !== this.id) {
                    this.id = newId;
                    await this.loadDataset();
                    await this.service.render();
                }
            }
        });
    }

    ngOnDestroy() {
        if (this.routerSub) this.routerSub.unsubscribe();
    }

    // ── Data Loading ──

    public async loadDataset() {
        this.loading = true;
        await this.service.render();
        const { code, data } = await wiz.call('get', { id: this.id });
        if (code === 200) {
            this.dataset = data.dataset;
            this.collection = data.collection || null;
            this.qaList = data.qa_list || [];
            this.totalPages = data.total_pages || 1;
            this.assignedUsers = data.assigned_users || [];
        } else {
            this.service.href('/dataset/finetune');
            return;
        }
        this.loading = false;
        await this.service.render();
    }

    public async loadPage(p: number) {
        if (p < 1 || p > this.totalPages) return;
        this.page = p;
        this.qaLoading = true;
        await this.service.render();
        const { code, data } = await wiz.call('qa_list', { dataset_id: this.id, page: this.page });
        if (code === 200) {
            this.qaList = data.list || [];
            this.totalPages = data.total_pages || 1;
        }
        this.qaLoading = false;
        await this.service.render();
    }

    // ── Finalize / Reopen ──

    get isCompleted(): boolean {
        return this.dataset?.status === 'completed';
    }

    get isReviewComplete(): boolean {
        if (!this.dataset) return false;
        const total = this.dataset.total_count || 0;
        if (total === 0) return false;
        const reviewed = (this.dataset.approved_count || 0) + (this.dataset.rejected_count || 0) + (this.dataset.skipped_count || 0);
        return reviewed >= total;
    }

    get reviewPercent(): number {
        if (!this.dataset) return 0;
        const total = this.dataset.total_count || 0;
        if (total === 0) return 0;
        const reviewed = (this.dataset.approved_count || 0) + (this.dataset.rejected_count || 0) + (this.dataset.skipped_count || 0);
        return Math.round((reviewed / total) * 100);
    }

    public async finalize() {
        if (!this.isReviewComplete) return;
        const res = await this.service.modal.show({
            title: '데이터셋 마감',
            message: '마감하면 QA 생성, 할당, 업로드, 삭제가 비활성화됩니다. 마감하시겠습니까?',
            action: '마감',
            actionBtn: 'bg-emerald-500 hover:bg-emerald-600',
            cancel: '취소'
        });
        if (!res) return;
        const { code } = await wiz.call('finalize', { dataset_id: this.id });
        if (code === 200) {
            await this.loadDataset();
        }
    }

    public async reopen() {
        const res = await this.service.modal.show({
            title: '마감 해제',
            message: '데이터셋 마감을 해제하고 검수 상태로 되돌리시겠습니까?',
            action: '해제',
            cancel: '취소'
        });
        if (!res) return;
        const { code } = await wiz.call('reopen', { dataset_id: this.id });
        if (code === 200) {
            await this.loadDataset();
        }
    }

    // ── QA Delete ──

    public async openDeleteQa(qa: any) {
        this.deleteQaTarget = qa;
        this.showDeleteQaModal = true;
        await this.service.render();
    }

    public async closeDeleteQaModal() {
        this.showDeleteQaModal = false;
        this.deleteQaTarget = null;
        await this.service.render();
    }

    public async confirmDeleteQa() {
        if (!this.deleteQaTarget) return;
        const { code } = await wiz.call('delete_qa', {
            qa_id: this.deleteQaTarget.id,
            dataset_id: this.id
        });
        if (code === 200) {
            this.showDeleteQaModal = false;
            this.deleteQaTarget = null;
            await this.loadDataset();
        } else {
            this.showDeleteQaModal = false;
            this.deleteQaTarget = null;
            await this.service.render();
        }
    }

    // ── Toolbar: Model Selection ──

    get openaiModels() {
        return this.models.filter(m => m.provider === 'OpenAI');
    }

    get googleModels() {
        return this.models.filter(m => m.provider === 'Google');
    }

    public async toggleModelDropdown() {
        this.showModelDropdown = !this.showModelDropdown;
        this.showDownloadDropdown = false;
        await this.service.render();
    }

    public async selectModel(model: any) {
        this.selectedModel = model;
        this.showModelDropdown = false;
        await this.service.render();
    }

    // ── Toolbar: Generate Modal ──

    public async openGenerateModal() {
        this.showGenerateModal = true;
        this.showModelDropdown = false;
        this.selectedSourceMode = 'single';
        this.promptsLoading = true;
        await this.service.render();

        // Load prompts for current user (empty = system defaults)
        await this.loadPrompts('');

        // Load prompt users list
        const { code, data } = await wiz.call('prompt_users');
        if (code === 200) {
            this.promptUsers = data.users || [];
        }

        this.promptsLoading = false;
        await this.service.render();
    }

    public async closeGenerateModal() {
        this.showGenerateModal = false;
        this.showPromptUserDropdown = false;
        await this.service.render();
    }

    public async loadPrompts(userId: string) {
        this.promptUserId = userId;
        const { code, data } = await wiz.call('get_prompts', { user_id: userId });
        if (code === 200) {
            this.prompts = data.prompts || {};
        }
        await this.service.render();
    }

    // ── Label Selection ──

    public async toggleMainLabel(key: string) {
        const idx = this.selectedMainLabels.indexOf(key);
        if (idx >= 0) {
            if (this.selectedMainLabels.length <= 1) {
                await this.service.modal.show({
                    title: '주라벨 필수',
                    message: '주라벨은 최소 1개 이상 선택해야 합니다.',
                    action: '확인'
                });
                return;
            }
            this.selectedMainLabels.splice(idx, 1);
            delete this.subLabelMap[key];
        } else {
            this.selectedMainLabels.push(key);
        }
        if (!this.isLabelSelected(this.activePromptTab)) {
            this.activePromptTab = this.selectedMainLabels[0] || 'system';
        }
        await this.service.render();
    }

    public async toggleSubLabelFor(mainKey: string, subKey: string) {
        if (this.subLabelMap[mainKey] === subKey) {
            delete this.subLabelMap[mainKey];
        } else {
            this.subLabelMap[mainKey] = subKey;
        }
        if (!this.isLabelSelected(this.activePromptTab)) {
            this.activePromptTab = this.selectedMainLabels[0] || 'system';
        }
        await this.service.render();
    }

    public isSubLabelSelectedFor(mainKey: string, subKey: string): boolean {
        return this.subLabelMap[mainKey] === subKey;
    }

    public getSubLabelName(mainKey: string): string {
        const subKey = this.subLabelMap[mainKey];
        if (!subKey) return '';
        const sub = this.subLabels.find((s: any) => s.key === subKey);
        return sub ? sub.name : subKey;
    }

    public get totalGenerateCount(): number {
        return this.generateCount * (this.selectedMainLabels.length || 1);
    }

    public async selectSourceMode(mode: string) {
        this.selectedSourceMode = mode === 'multi' ? 'multi' : 'single';
        await this.service.render();
    }

    public get isMultiFileMode(): boolean {
        return this.selectedSourceMode === 'multi';
    }

    public get progressSelectionStrategyLabel(): string {
        if (this.progressSelectionStrategy === 'semantic_search') return '의미 기반 검색';
        if (this.progressSelectionStrategy === 'label_relevance') return '라벨 관련도 기반';
        return '자동 선택';
    }

    public isMainLabelSelected(key: string): boolean {
        return this.selectedMainLabels.includes(key);
    }

    public isLabelSelected(key: string): boolean {
        if (key === 'system') return true;
        if (this.selectedMainLabels.includes(key)) return true;
        for (const mk of this.selectedMainLabels) {
            if (this.subLabelMap[mk] === key) return true;
        }
        return false;
    }

    // ── Prompt Tab ──

    public async setActivePromptTab(key: string) {
        this.activePromptTab = key;
        await this.service.render();
    }

    public getPromptText(key: string): string {
        return this.prompts[key]?.prompt_text || '';
    }

    public updatePromptText(key: string, text: string) {
        if (this.prompts[key]) {
            this.prompts[key].prompt_text = text;
            this.prompts[key].is_default = false;
        }
    }

    public get activePromptTabs(): any[] {
        const tabs: any[] = [{ key: 'system', name: '시스템', type: 'system' }];
        for (const ml of this.mainLabels) {
            if (!this.selectedMainLabels.includes(ml.key)) continue;
            tabs.push({ ...ml, type: 'main', divider: true });
            const subKey = this.subLabelMap[ml.key];
            if (subKey) {
                const sl = this.subLabels.find((s: any) => s.key === subKey);
                if (sl) tabs.push({ ...sl, type: 'sub', parentMain: ml.key });
            }
        }
        return tabs;
    }

    public getTabClass(tab: any): string {
        if (this.activePromptTab !== tab.key) {
            return 'border-transparent text-zinc-400 hover:text-zinc-600';
        }
        if (tab.type === 'main') return 'border-indigo-500 text-indigo-600 bg-white';
        if (tab.type === 'sub') return 'border-violet-500 text-violet-600 bg-white';
        return 'border-zinc-500 text-zinc-700 bg-white';
    }

    public get activePromptTabType(): string {
        const tab = this.activePromptTabs.find(t => t.key === this.activePromptTab);
        return tab?.type || 'system';
    }

    // ── Prompt User Selection ──

    public async togglePromptUserDropdown() {
        this.showPromptUserDropdown = !this.showPromptUserDropdown;
        await this.service.render();
    }

    public async selectPromptUser(userId: string) {
        this.showPromptUserDropdown = false;
        this.promptsLoading = true;
        await this.service.render();
        await this.loadPrompts(userId);
        this.promptsLoading = false;
        await this.service.render();
    }

    public get currentPromptUserName(): string {
        if (!this.promptUserId) return '기본(원본)';
        const user = this.promptUsers.find(u => u.id === this.promptUserId);
        return user ? user.name : this.promptUserId;
    }

    // ── Prompt Save / Reset ──

    public async saveAllPrompts() {
        if (this.promptSaving) return;
        this.promptSaving = true;
        await this.service.render();

        const userId = this.service.auth.session?.id || '';
        if (!userId) {
            this.promptSaving = false;
            await this.service.render();
            return;
        }

        for (const key of Object.keys(this.prompts)) {
            const prompt = this.prompts[key];
            if (!prompt.is_default) {
                await wiz.call('save_prompt', {
                    user_id: userId,
                    label_key: key,
                    prompt_text: prompt.prompt_text
                });
            }
        }

        this.promptUserId = userId;
        this.promptSaving = false;
        await this.service.render();

        await this.service.modal.show({
            title: '저장 완료',
            message: '프롬프트가 저장되었습니다.',
            action: '확인'
        });
    }

    public async resetAllPrompts() {
        this.promptsLoading = true;
        await this.service.render();
        await this.loadPrompts('');
        this.promptsLoading = false;
        await this.service.render();
    }

    // ── Generate Confirm ──

    public async confirmGenerate() {
        if (this.generating) return;
        if (this.selectedMainLabels.length === 0) {
            await this.service.modal.show({
                title: '주라벨 필수',
                message: '주라벨을 최소 1개 이상 선택해주세요.',
                action: '확인'
            });
            return;
        }
        this.showGenerateModal = false;
        this.generating = true;

        // 진행바 모달 초기화
        this.showProgressModal = true;
        this.progressStep = 'init';
        this.progressMessage = '생성 준비 중...';
        this.progressPercent = 0;
        this.progressSaved = 0;
        this.progressTotal = 0;
        this.progressError = '';
        this.progressDone = false;
        this.progressSelectedFiles = [];
        this.progressSelectedFileDetails = [];
        this.progressContextLabel = '';
        this.progressSelectionStrategy = '';
        await this.service.render();

        // 그룹 구성: 주라벨당 0~1개의 보조라벨
        const groups: any[] = [];
        for (const mainKey of this.selectedMainLabels) {
            const mainLabel = this.mainLabels.find((l: any) => l.key === mainKey);
            const subKey = this.subLabelMap[mainKey] || '';
            const subLabel = subKey ? this.subLabels.find((l: any) => l.key === subKey) : null;
            groups.push({
                main: mainKey,
                main_prompt: this.getPromptText(mainKey),
                sub: subKey,
                sub_prompt: subLabel ? this.getPromptText(subKey) : '',
            });
        }

        const formData = new FormData();
        formData.append('dataset_id', this.id);
        formData.append('model_id', this.selectedModel.id);
        formData.append('count', String(this.generateCount));
        formData.append('source_mode', this.selectedSourceMode);
        formData.append('system_prompt', this.getPromptText('system'));
        formData.append('groups', JSON.stringify(groups));

        let terminalEventReceived = false;

        try {
            const response = await fetch(
                '/wiz/api/page.dataset.finetune.detail/generate',
                { method: 'POST', body: formData }
            );

            if (!response.ok || !response.body) {
                throw new Error(`HTTP ${response.status}`);
            }

            const reader = response.body!.getReader();
            const decoder = new TextDecoder();
            let buffer = '';

            while (true) {
                const { done, value } = await reader.read();
                if (done) break;

                buffer += decoder.decode(value, { stream: true });
                const lines = buffer.split('\n\n');
                buffer = lines.pop() || '';

                for (const line of lines) {
                    if (line.startsWith('data: ')) {
                        try {
                            const event = JSON.parse(line.slice(6));
                            if (event.type === 'complete' || event.type === 'error') {
                                terminalEventReceived = true;
                            }
                            await this.handleGenerateEvent(event);
                        } catch {}
                    }
                }
            }

            if (!terminalEventReceived) {
                if (this.progressSaved > 0) {
                    this.progressError = `연결이 중간에 끊어졌습니다. 다만 ${this.progressSaved}개까지는 저장되었을 수 있어 목록을 새로고침했습니다.`;
                    this.page = 1;
                    await this.loadDataset();
                } else {
                    this.progressError = '생성 스트림 연결이 중간에 종료되었습니다. 다시 시도해주세요.';
                }
                this.progressDone = true;
                await this.service.render();
            }
        } catch (e: any) {
            if (this.progressSaved > 0) {
                this.progressError = `네트워크 오류로 연결이 끊어졌지만 ${this.progressSaved}개는 저장되었을 수 있어 목록을 새로고침했습니다. (${e.message || '연결 실패'})`;
                this.page = 1;
                await this.loadDataset();
            } else {
                this.progressError = `네트워크 오류: ${e.message || '연결 실패'}`;
            }
            this.progressDone = true;
            await this.service.render();
        }

        this.generating = false;
        await this.service.render();
    }

    private async handleGenerateEvent(event: any) {
        if (event.type === 'progress') {
            this.progressStep = event.step || '';
            this.progressMessage = event.message || '';
            this.progressPercent = event.percent || 0;
            if (event.saved !== undefined) this.progressSaved = event.saved;
            if (event.total !== undefined) this.progressTotal = event.total;
            if (event.selected_files !== undefined) this.progressSelectedFiles = event.selected_files || [];
            if (event.selected_file_details !== undefined) this.progressSelectedFileDetails = event.selected_file_details || [];
            if (event.group_label !== undefined) this.progressContextLabel = event.group_label || '';
            if (event.selection_strategy !== undefined) this.progressSelectionStrategy = event.selection_strategy || '';
        } else if (event.type === 'complete') {
            this.progressStep = 'complete';
            this.progressMessage = event.message || 'QA 생성 완료';
            this.progressPercent = 100;
            if (event.saved !== undefined) this.progressSaved = event.saved;
            if (event.total !== undefined) this.progressTotal = event.total;
            this.progressDone = true;
        } else if (event.type === 'error') {
            this.progressError = event.message || '알 수 없는 오류';
            this.progressDone = true;
        }
        await this.service.render();
    }

    public async closeProgressModal() {
        this.showProgressModal = false;
        await this.service.render();
        if (!this.progressError) {
            this.page = 1;
            await this.loadDataset();
        }
    }

    // ── Toolbar: Assign ──

    public async openAssignModal() {
        this.showAssignModal = true;
        this.loadingUsers = true;
        this.selectedUserIds = this.assignedUsers.map((u: any) => u.id);
        await this.service.render();

        const { code, data } = await wiz.call('users');
        if (code === 200) {
            this.userList = data.users || [];
        }
        this.loadingUsers = false;
        await this.service.render();
    }

    public async closeAssignModal() {
        this.showAssignModal = false;
        await this.service.render();
    }

    public isUserSelected(userId: string): boolean {
        return this.selectedUserIds.includes(userId);
    }

    public async toggleUserSelection(userId: string) {
        const idx = this.selectedUserIds.indexOf(userId);
        if (idx >= 0) {
            this.selectedUserIds.splice(idx, 1);
        } else {
            this.selectedUserIds.push(userId);
        }
        await this.service.render();
    }

    public async saveAssignment() {
        await wiz.call('assign', { dataset_id: this.id, user_ids: JSON.stringify(this.selectedUserIds) });
        this.showAssignModal = false;
        await this.loadDataset();
    }

    // ── Toolbar: Download ──

    public async toggleDownloadDropdown() {
        this.showDownloadDropdown = !this.showDownloadDropdown;
        this.showModelDropdown = false;
        this.showDownloadUsers = false;
        await this.service.render();
    }

    public async downloadExcel(type: string) {
        if (type === 'user') {
            this.showDownloadUsers = !this.showDownloadUsers;
            if (this.showDownloadUsers && this.downloadUserList.length === 0) {
                this.downloadUsersLoading = true;
                await this.service.render();
                const { code, data } = await wiz.call('users');
                if (code === 200) {
                    this.downloadUserList = data.users || [];
                }
                this.downloadUsersLoading = false;
            }
            await this.service.render();
            return;
        }

        this.showDownloadDropdown = false;
        this.showDownloadUsers = false;
        await this.service.render();

        try {
            const response = await fetch(
                `/wiz/api/page.dataset.finetune.detail/download?dataset_id=${this.id}&type=${type}`
            );
            if (!response.ok) return;

            const blob = await response.blob();
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `${this.dataset?.title || 'dataset'}_QA.xlsx`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
        } catch (e) {
            // download failed silently
        }
    }

    public async downloadExcelForUser(user: any) {
        this.showDownloadDropdown = false;
        this.showDownloadUsers = false;
        await this.service.render();

        try {
            const response = await fetch(
                `/wiz/api/page.dataset.finetune.detail/download?dataset_id=${this.id}&type=user&user_id=${encodeURIComponent(user.id)}`
            );
            if (!response.ok) return;

            const blob = await response.blob();
            const disposition = response.headers.get('Content-Disposition') || '';
            let filename = `${this.dataset?.title || 'dataset'}_${user.name}_QA.xlsx`;

            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
        } catch (e) {
            // download failed silently
        }
    }

    // ── Toolbar: Upload ──

    public async triggerUpload() {
        if (this.uploading) return;
        const input = document.createElement('input');
        input.type = 'file';
        input.accept = '.xlsx,.xls';
        input.onchange = async (e: any) => {
            const file = e.target.files?.[0];
            if (!file) return;

            this.uploading = true;
            await this.service.render();

            try {
                const formData = new FormData();
                formData.append('file', file);

                const response = await fetch(
                    `/wiz/api/page.dataset.finetune.detail/upload?dataset_id=${this.id}`,
                    { method: 'POST', body: formData }
                );
                const result = await response.json();

                if (result.code === 200) {
                    await this.service.modal.show({
                        title: '업로드 완료',
                        message: `성공: ${result.data?.success || 0}건, 실패: ${result.data?.failed || 0}건`,
                        action: '확인'
                    });
                }
            } catch (e) {
                // upload failed
            }

            this.uploading = false;
            this.page = 1;
            await this.loadDataset();
        };
        input.click();
    }

    // ── Status Helpers ──

    public statusLabel(status: string): string {
        const map: any = { draft: '초안', generating: '생성 중', review: '검수 중', completed: '완료' };
        return map[status] || status;
    }

    public statusColor(status: string): string {
        const map: any = {
            draft: 'bg-zinc-100 text-zinc-600',
            generating: 'bg-amber-50 text-amber-600',
            review: 'bg-violet-50 text-violet-600',
            completed: 'bg-emerald-50 text-emerald-600'
        };
        return map[status] || 'bg-zinc-100 text-zinc-600';
    }

    public qaStatusLabel(status: string): string {
        const map: any = { pending: '대기', approved: '승인', rejected: '반려', skipped: '건너뜀' };
        return map[status] || status;
    }

    public qaStatusColor(status: string): string {
        const map: any = {
            pending: 'bg-zinc-100 text-zinc-500',
            approved: 'bg-emerald-50 text-emerald-600',
            rejected: 'bg-red-50 text-red-600',
            skipped: 'bg-amber-50 text-amber-600'
        };
        return map[status] || 'bg-zinc-100 text-zinc-500';
    }

    // ── Metadata Helpers ──

    public getModelName(modelId: string): string {
        const map: any = {
            'gpt-5': 'GPT-5', 'gpt-5-mini': 'GPT-5 Mini', 'gpt-5-turbo': 'GPT-5 Turbo',
            'gemini-3.1-pro-preview': 'Gemini 3.1 Pro Preview',
            'gemini-3-flash-preview': 'Gemini 3 Flash Preview',
            'gemini-3.1-flash-lite-preview': 'Gemini 3.1 Flash Lite Preview',
        };
        return map[modelId] || modelId;
    }

    public getLabelName(key: string): string {
        const all = [...this.mainLabels, ...this.subLabels];
        const found = all.find(l => l.key === key);
        return found ? found.name : key;
    }

    // ── Source Display ──

    public async toggleSource(qaId: string) {
        this.expandedSources[qaId] = !this.expandedSources[qaId];
        await this.service.render();
    }

    public getSourceChunks(qa: any): any[] {
        if (!qa.source_chunks) return [];

        let chunks: any[] = [];
        if (typeof qa.source_chunks === 'string') {
            try {
                chunks = JSON.parse(qa.source_chunks);
            } catch {
                chunks = [];
            }
        } else {
            chunks = qa.source_chunks || [];
        }

        const deduped: any[] = [];
        const seen = new Set<string>();
        for (const src of chunks) {
            const key = [
                src?.source_id || '',
                src?.file_name || 'unknown',
                src?.page_number || '?',
                src?.excerpt || '',
                (src?.text || '').slice(0, 200),
            ].join('::');
            if (seen.has(key)) continue;
            seen.add(key);
            deduped.push(src);
        }

        return deduped;
    }

    public getSourceFileCount(qa: any): number {
        const chunks = this.getSourceChunks(qa);
        const files = new Set<string>();
        for (const src of chunks) {
            if (src?.file_name) files.add(src.file_name);
        }
        return files.size;
    }

    // ── PDF Viewer ──

    public async openPdfViewer(src: any) {
        this.pdfViewerSrc = src;
        const collectionId = this.dataset?.collection_id || '';
        const sourcePath = src?.source_path || src?.file_name || '';
        this.pdfImageUrl = `/wiz/api/page.collections/pdf_page_image?id=${collectionId}&path=${encodeURIComponent(sourcePath)}&page=${src.page_number}`;
        this.showPdfViewer = true;
        await this.service.render();
    }

    public async closePdfViewer() {
        this.showPdfViewer = false;
        this.pdfViewerSrc = null;
        this.pdfImageUrl = '';
        await this.service.render();
    }

    public goBack() {
        this.service.href('/dataset/finetune');
    }
}

export default PageDatasetFinetuneDetailComponent;